import React from "react"
import xhsImg from "@images/gamesPage/47aa.png"
import btnXhsImg from "@images/gamesPage/48aa.png"

import { ItemSection } from "@src/components/tabs/itemSection"
import * as styles from "./xiaohongshu.module.scss"
import Clickable from "@src/components/clickable"
import config from "@config"

const Xiaohongshu = () => {
  return (
    <div>
      <img src={xhsImg} alt="xiaohongshu" className={styles.xhs} />
      <ItemSection all="活动介绍">
        <p>
          一个月开发一款游戏，你想听听他们的故事吗？
          <br />
          这次我们邀请到了各位开发者，与我们分享游戏开发中的点滴故事，讲讲他们的游戏设计理念，并有幕后设计稿大揭秘哦～来看看大家快乐的创作之旅吧～
        </p>
        <p>
          <Clickable appNavTo={config.links.xhs} className="img-btn mr-3">
            <img src={btnXhsImg} alt="跳转到小红书" />
          </Clickable>
        </p>
      </ItemSection>
    </div>
  )
}

export default Xiaohongshu
